import type React from 'react';

import { SynchronizeStatus } from '@vlabs/monokit/entities/sources';

import { useSourceStreamLastFrameTranslation } from './i18n';
import st from './SourceStreamLastFrame.module.sass';

// Легенда «Обозначения»: зелёная иконка — наследует настройки группы,
// серая — использует собственные настройки.
function SourceStreamLegend(): React.JSX.Element {
  const { t } = useSourceStreamLastFrameTranslation();

  return (
    <div className={st.Legend}>
      <p className={st.LegendTitle}>{t('legend_title')}</p>

      <div className={st.LegendRow}>
        <SynchronizeStatus synchronized />
        <span className={st.LegendText}>{t('legend.inherits')}</span>
      </div>

      <div className={st.LegendRow}>
        <SynchronizeStatus synchronized={false} />
        <span className={st.LegendText}>{t('legend.own')}</span>
      </div>
    </div>
  );
}

export { SourceStreamLegend };
